import React from 'react';
import ModernHeader from '../components/ModernHeader';
import Footer from '../components/Footer';
import { useSettings } from '../context/SettingsContext';

const AboutUs = () => {
  const { settings } = useSettings();
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
      <ModernHeader tenant={{ name: 'Tiket Jini' }} />
      <div style={{ maxWidth: '800px', margin: '0 auto', background: 'white', borderRadius: '20px', padding: '40px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)', marginTop: '40px', marginBottom: '40px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src="/Logo1.png" alt="Tiket Jini" style={{ width: '80px', height: '80px', borderRadius: '16px', marginBottom: '20px' }} />
          <h1 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#2d3748', marginBottom: '10px' }}>About Tiket Jini</h1>
          <p style={{ color: '#64748b', fontSize: '1.2rem' }}>Your Gateway to Amazing Experiences</p>
        </div>

        <div style={{ lineHeight: '1.8', color: '#4a5568' }}>
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>🚀 Our Mission</h2>
            <p>Tiket Jini is dedicated to making ticket booking simple, secure, and seamless. We connect you with amazing experiences across parks, temples, events, and attractions throughout India.</p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>🌟 What We Offer</h2>
            <ul style={{ paddingLeft: '20px' }}>
              <li>🎢 Adventure Parks & Theme Parks</li>
              <li>🛕 Religious Sites & Temples</li>
              <li>🎭 Cultural Events & Shows</li>
              <li>🏛️ Museums & Heritage Sites</li>
              <li>🌊 Beach Resorts & Water Parks</li>
              <li>🏢 Banquet Halls & Event Venues</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>💡 Why Choose Us</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
              <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <h3 style={{ color: '#3b82f6', marginBottom: '10px' }}>⚡ Instant Booking</h3>
                <p style={{ fontSize: '14px' }}>Book tickets instantly with real-time availability and immediate confirmation.</p>
              </div>
              <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <h3 style={{ color: '#3b82f6', marginBottom: '10px' }}>🔒 Secure Payments</h3>
                <p style={{ fontSize: '14px' }}>Multiple payment gateways with bank-level security for safe transactions.</p>
              </div>
              <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <h3 style={{ color: '#3b82f6', marginBottom: '10px' }}>📱 Digital Tickets</h3>
                <p style={{ fontSize: '14px' }}>QR code tickets delivered instantly to your phone - no printing required.</p>
              </div>
              <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <h3 style={{ color: '#3b82f6', marginBottom: '10px' }}>🎯 Best Prices</h3>
                <p style={{ fontSize: '14px' }}>Competitive pricing with special discounts for children and groups.</p>
              </div>
            </div>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>🏆 Our Achievements</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '20px', textAlign: 'center' }}>
              <div>
                <div style={{ fontSize: '2rem', color: '#3b82f6', fontWeight: 'bold' }}>10,000+</div>
                <div style={{ fontSize: '14px', color: '#64748b' }}>Happy Customers</div>
              </div>
              <div>
                <div style={{ fontSize: '2rem', color: '#3b82f6', fontWeight: 'bold' }}>500+</div>
                <div style={{ fontSize: '14px', color: '#64748b' }}>Partner Venues</div>
              </div>
              <div>
                <div style={{ fontSize: '2rem', color: '#3b82f6', fontWeight: 'bold' }}>50+</div>
                <div style={{ fontSize: '14px', color: '#64748b' }}>Cities Covered</div>
              </div>
              <div>
                <div style={{ fontSize: '2rem', color: '#3b82f6', fontWeight: 'bold' }}>24/7</div>
                <div style={{ fontSize: '14px', color: '#64748b' }}>Customer Support</div>
              </div>
            </div>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>🤝 Our Commitment</h2>
            <p>We are committed to providing exceptional service, transparent pricing, and memorable experiences. Our team works tirelessly to ensure every booking is smooth and every visit is unforgettable.</p>
          </section>
        </div>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              marginRight: '15px'
            }}
          >
            ← Back to Home
          </button>
          <button
            onClick={() => window.location.href = '/contact'}
            style={{
              background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Contact Us →
          </button>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default AboutUs;